import { lazy } from "react";
import type { SolutionRoute } from "../routes";
import type { SolutionSettings } from "../settings";
import type { NavItem } from "../../nav";
import { Icon } from "../../ui";
import "./recaps.css";

const RecapsPage = lazy(() => import("./page").then((m) => ({ default: m.RecapsPage })));
const RecapsSettings = lazy(() => import("./settings").then((m) => ({ default: m.RecapsSettings })));

/** Recap cards: after each event, everyone who came gets a card made for them to share. */

export const routes: SolutionRoute[] = [{ solution: "recaps", path: "recaps", element: <RecapsPage /> }];

export const settings: SolutionSettings[] = [{ solution: "recaps", key: "recaps", label: "Recap cards", icon: Icon.image, need: "recaps.view", Component: RecapsSettings }];

export const nav: NavItem = { to: "/recaps", label: "Recap cards", icon: Icon.image, solution: "recaps", need: "recaps.view" };
